export const app_navbar_routes = {
  auth: {},
  app: {
    planning: {
      bdl: "/planning/bdl",
    },
    dashboard: "/dashboard",
    expense: {
      root: "/expense",
      claim_expenses: "/expense/claim-expenses",
      advance_expenses: "/expense/advance-expenses",
      vendor_payments: "/expense/vendor-payments",
      category_head: "/expense/category-head",
    },
    grn: {
      gate_entry: "/grn/gate-entry",
      grn: "/grn/grn",
      internal_store_transfer: "/grn/internal-store-transfer",
    },
    purchaseInvoice: {
      purchaseInvoice: "/purchase-invoice/purchase-invoice",
    },
    serviceInvoice: {
      serviceInvoice: "/service-invoice/service-invoice",
    },
    service: {
      service_requesition: "/service/service-requesition",
      service_order: "/service/service-order",
    },
    ledger: {
      ledger: "/ledger/ledger",
    },
    material_request: "/material-requests",
    approvals: {
      expenses: "/approvals/expenses",
      material_request: "/approvals/material-requests",
      purchase_order: "/approvals/purchase-orders",
      purchase_invoice: "/approvals/purchase-invoices",
      service_order: "/approvals/service-orders",
      service_invoice: "/approvals/service-invoices",
      purchase_requesition: "/approvals/purchase-requesition",
      service_requesition: "/approvals/service-requesition",
    },
    material_allocation: {
      mr_wise: "/material-allocations/mr-wise",
      project_wise: "/material-allocations/project-wise",
    },
    requisitions_and_orders: {
      purchase_requisition: "/requisitions-and-orders/purchase-requisition",
      purchase_order: "/requisitions-and-orders/purchase-order",
    },
  },
};
